import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

/**
 * Get subTenantId query param
 */
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// Helper: build query param for subTenantId
const getSubTenantIdParam = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
    const subTenantId = decodedToken?.subTenantId;
    return subTenantId ? `&subTenantId=${subTenantId}` : "";
  } else if (switched && switchedSubtenant) {
    return `&subTenantId=${switchedSubtenant?.id}`;
  }
  return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers with conditional tenant-login
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const CleaningTraceabilityApi = { 
  // Create Traceability Item Api
  CreateCleaningTraceability: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    return apiApp
      .post(`/cleaningTaskMaster`, jsonData, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },


  CreateCleaningTraceabilitycommon: (data, datatype) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    return apiApp
      .post(`/cleaningTraceability?Traceability-Type=${datatype}`, jsonData, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  PutCleaningTraceabilitycommon: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    return apiApp
      .put(`/cleaningTraceability/addManagerNote`, jsonData, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  CreateCleaningTraceabilityMonthly: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    return apiApp
      .post(`/cleaningTraceability?Traceability-Type=monthly`, jsonData, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListCleaningTraceability: (page, limit, frequency) => {
    return apiApp
      .get(
        `/cleaningTaskMaster?page=${page}&size=${limit}&sort=desc&frequency=${frequency}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListCleaningTraceabilityForToday: (date, frequency) => {
    return apiApp
      .get(
        `/cleaningTaskInstance/date/${date}?frequency=${frequency}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  TasksMarkComplete: (TaskID, data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    return apiApp
      .put(
        `/cleaningTaskInstance/${TaskID}/complete?frequency=${jsonData.frequency}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        jsonData,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },


  TasksAddManagerNote: (TaskID, data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    return apiApp
      .put(
        `/cleaningTaskInstance/${TaskID}/managerNote?managerNote=${jsonData.managerNote}&frequency=${jsonData.frequency}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        jsonData,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },


  UpdateCleaningTraceability: (ListcleaningID, data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    return apiApp
      .put(
        `/cleaningTaskMaster/${ListcleaningID}`,
        jsonData,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  DeleteCleaningTraceability: (TraceabilityItemID) => {
    return apiApp
      .delete(
        `/cleaningTaskMaster/${TraceabilityItemID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListCleaningTraceabilityCommon: (type) => {
    return apiApp
      .get(
        `/cleaningTraceability?Traceability-Type=${type}&size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListcleaningTraceabilityAssign: () => {
    return apiApp
      .get(
        `/cleaningTraceabilityAssign?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListcleaningTraceabilityAssign2: (page, limit) => {
    return apiApp
      .get(
        `/cleaningTraceabilityAssign?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  PutcleaningTraceabilityAssign: (ListcleaningID, data, dataType) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    return apiApp
      .put(
        `/cleaningTraceabilityAssign/${ListcleaningID}?traceability-Type=${dataType}`,
        jsonData,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  SinglecleaningTraceabilityAssign: (ListcleaningID, dataType) => {
    return apiApp
      .get(
        `/cleaningTraceabilityAssign/${ListcleaningID}?traceability-Type=${dataType}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListCleaningTraceabilitydaily: () => {
    return apiApp
      .get(
        `/cleaningTraceability?size=100&Traceability-Type=daily&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListCleaningTraceabilityweekly: () => {
    return apiApp
      .get(
        `/cleaningTraceability?size=100&Traceability-Type=weekly&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListCleaningTraceabilitymonthly: () => {
    return apiApp
      .get(
        `/cleaningTraceability?size=100&Traceability-Type=monthly&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  SingleCleaningTraceabilityCommon: (TraceabilityItemID, traceabilityType) => {
    return apiApp
      .get(
        `/cleaningTraceability/${TraceabilityItemID}?traceabilityType=${traceabilityType}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  SingleCleaningTraceability: (TraceabilityItemID) => {
    return apiApp
      .get(
        `/cleaningTraceability/${TraceabilityItemID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  SingleCleaningTraceability2: (TraceabilityItemID, type) => {
    return apiApp
      .get(
        `/cleaningTraceability/${TraceabilityItemID}?traceabilityType=${type}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default CleaningTraceabilityApi;
